import {Component, Inject, OnInit} from '@angular/core';
import {User} from '../../../data/models/user';
import {FormBuilder, FormGroup} from '@angular/forms';
import {UserService} from '../../../services/api/user.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {USER_VALIDATORS} from '../../../../constants/validators';

@Component({
  selector: 'app-user-reset-password-dialog',
  templateUrl: './user-reset-password-dialog.component.html',
  styleUrls: ['./user-reset-password-dialog.component.css']
})
export class UserResetPasswordDialogComponent implements OnInit {

  public user: User;
  public userForm: FormGroup;
  public passwordHide = true;

  constructor(
    private userService: UserService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<UserResetPasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      user: User,
    },
  ) {
    this.user = this.data.user;
    this.userForm = this.fb.group({
      password: ['', USER_VALIDATORS.PASSWORD],
    });
  }

  ngOnInit(): void {
  }

  onSubmit(event: MouseEvent): void {
    event.preventDefault();
    if (this.userForm.valid) {
      this.userService.updateUser(this.user.id, {
        password: this.userForm.controls.password.value,
      })
        .then(user => this.dialogRef.close(user))
        .catch(error => {
        });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
